import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import TabsComponent from "./utils/TabsComponent/TabsComponent";
import { useLocation } from "react-router-dom";

const MainContainer = ({ children, offPadding, hideTabs = true }) => {
  const location = useLocation();

  const [scrollDown, setScrollDown] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;

      const maxScroll =
        document.documentElement.scrollHeight - window.innerHeight;

      if (currentY > 0 && currentY < maxScroll) {
        if (currentY > lastScrollY.current + 5) {
          setScrollDown(true);
        }

        if (currentY < lastScrollY.current - 5 || currentY < 10) {
          setScrollDown(false);
        }

        lastScrollY.current = currentY;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setScrollDown(false);
  }, [location]);

  return (
    <Container>
      <Header />
      {!hideTabs && <TabsComponent hidden={scrollDown} />}
      <Content $offPadding={offPadding} $hideTabs={hideTabs}>
        {children} <Footer />
      </Content>
    </Container>
  );
};

export default MainContainer;

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: 100dvh;
  background-color: #0e0e12;
  color: white;
  width: 100%;
  transition: background-color 0.3s ease, color 0.3s ease;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
  max-height: 100dvh;
  min-height: 100dvh;
  padding: ${(props) => (props.$offPadding ? "0rem" : "2rem")};
  padding-top: calc(64px + ${({ $hideTabs }) => (!$hideTabs ? "64px" : "0px")});
  color: white;
  transition: color 0.3s ease;
  max-width: 1440px;

  gap: ${({ $hideTabs }) => (!$hideTabs ? 0 : "16px")};

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
